<script>
  import { SvelteUIProvider } from "@svelteuidev/core";
  import { Router, Link, Route, navigate, useLocation } from "svelte-routing";
  import { onMount, tick } from "svelte";
 import NavDomino from "./NavDomino.svelte";
 import Partidas from "./partidas.svelte";
 import ClassificaoDomino from "./ClassificacaoDomino.svelte";

  function PegaParametro(e) {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get(e);
    return id;
  }
  

  
 

  
  export let url = "";
</script>
<NavDomino />

  <Router {url}>
    <div class="layout">
      
      <div class="content">
       
        <Route path="/classificacao" component={ClassificaoDomino} />
         <Route path="/" component={Partidas} />
         <Route path="/partida">
          <Partidas id={PegaParametro("id")} />
        </Route>
       
      </div>
    </div>
  </Router>



<style>
  .layout {
    display: flex;
    flex-direction: row;
  }

  .content {
    flex-grow: 1;
  }
</style>
